import { ColorRGB, ColorRGBnormalize, ColorReference } from '../../values/index.js';
import * as Ruleset from '../../methods/set.js';
export const Reference = (color) => {
    var _a;
    if (!color) {
        return {
            id: null,
            alpha: null
        };
    }
    // Fixme: ColorReference accepting Colors is not type-safe concept.
    // Need to figure out how to deal with it another way.
    if (ColorRGB.isValid(color)) {
        return color;
    }
    let id = color.id || null;
    let alpha = (_a = color.alpha) !== null && _a !== void 0 ? _a : null;
    return {
        id,
        alpha
    };
};
// Checks if a color reference is valid, meaning respective color exists. If it is, that reference is returned, otherwise, a
// color reference with id being the internal color's id and alpha the current color's alpha is returned.
export const fixReference = (color, styles) => {
    if (color == null)
        return null;
    // TODO: This looks a lot like ColorReference() normalize function that generates something different.
    if (!ColorReference.isValid(color))
        return ColorReference({});
    if (!('id' in color))
        return color;
    // If it doesn't exist return a color reference with color id the internal color's id.
    if (!Ruleset.findByTypeAndId(styles, 'color', color.id)) {
        return { id: Ruleset.findBlankId(styles, 'color'), alpha: color.alpha };
    }
    return color;
};
export const Props = (props = {}) => ColorRGBnormalize(props);
export const validate = ColorRGB.isValid;
export const fix = (props, styles) => props;
export const label = 'Color';
export const type = 'color';
export const forms = [
    { id: 'color', label: 'Colors', extractProperties: (props) => props, validate: () => true }
];
export const category = 'basic';
//# sourceMappingURL=color.js.map